import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import { extractTextFromHTML } from '../components/employer/workshifts/workshifts.component'
import moment from 'moment'
import { formatTime } from './openForWork.utils'

export const generateJournalPdf = (data, t, invoice_lang) => {
  const doc = new jsPDF()
  const pageHeight = doc.internal.pageSize.height
  const lineHeight = 8
  const margin = 10

  const text = invoice_lang ? eng_text : fi_text

  doc.setFont('helvetica', 'bold')
  doc.setTextColor('#F67131')
  doc.text(text.title, 60, 10)

  data.forEach((item, index) => {
    const totalJournalHours = item.dateTimeRows.reduce(
      (sum, row) => sum + row.totalHour,
      0
    )

    let yPosition = margin + 20

    const text_task_description = `${text.p4}: ${extractTextFromHTML(
      item.task_description
    )}`
    const wrapped_text_task_description = doc.splitTextToSize(
      text_task_description,
      doc.internal.pageSize.width - 2 * margin
    )

    // General info section
    doc.setFont('helvetica', 'normal')
    doc.setTextColor('black')
    doc.setFontSize(12)

    doc.text(`${text.p1}: ${item.journal_id}`, margin, yPosition)
    yPosition += lineHeight
    doc.text(`${text.p2}: ${totalJournalHours}`, margin, yPosition)
    yPosition += lineHeight
    doc.text(
      `${text.p3}: ${new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(item.totalJournalAmount)}`,
      margin,
      yPosition
    )
    yPosition += lineHeight

    wrapped_text_task_description.forEach((line) => {
      if (yPosition + lineHeight > pageHeight - margin) {
        doc.addPage()
        yPosition = margin
      }
      doc.text(line, margin, yPosition)
      yPosition += lineHeight
    })

    const columns = [
      text.col1,
      text.col2,
      text.col3,
      text.col4,
      text.col5,
      text.col6,
      text.col7
    ]

    const rows = item.dateTimeRows.map((el) => [
      moment(el.date).format('DD.MM.YYYY'),
      formatTime(el.startTime),
      formatTime(el.endTime),
      el.totalHour,
      new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(el.amount),
      el.additionalInfo,
      new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(el.totalAmount)
    ])

    doc.autoTable({
      head: [columns],
      body: rows,
      startY: yPosition + lineHeight,
      headStyles: { fillColor: '#44c0cc', textColor: 255 },
      alternateRowStyles: { fillColor: '#e0eff3' },
      columnStyles: {
        5: { cellWidth: 40 }
      },
      styles: {
        overflow: 'linebreak' // Ensures text wraps within the cell
      }
    })

    if (index < data.length - 1) {
      doc.addPage()
    }
  })

  return doc.output('datauristring')
}

const fi_text = {
  title: 'Liitetyn työvuorojen päiväkirjan tiedot',
  p1: 'Päiväkirjanro.',
  p2: 'Kokonais­tunnit',
  p3: 'Päiväkirjan kokonaissumma',
  p4: 'Tehtävän kuvaus',
  col1: 'Päivämäärä',
  col2: 'Aloitusaika',
  col3: 'Loppuaika',
  col4: 'Tehdyt tunnit',
  col5: 'Määrä €/h',
  col6: 'Lisätiedot',
  col7: 'Kokonaismäärä'
}

const eng_text = {
  title: 'Attached work shifts journal data',
  p1: 'Journal no',
  p2: 'Total hours',
  p3: 'Total journal amount',
  p4: 'Task description',
  col1: 'Date',
  col2: 'Start time',
  col3: 'End time',
  col4: 'Worked hours',
  col5: 'Amount €/h',
  col6: 'Additional information',
  col7: 'Total amount'
}
